//removeIf(production)
import FloatWithTwoDecimals from "../../../../../domain/entities/float-with-two-decimals";
import ClaroluzCupsData from "../../../../../domain/entities/claroluz-cups-data";
import CupsOption from "../../../../../enums/cups-option";
import ClaroluzAlerts from "../../shared/alert/alerts.4";
import ClaroluzValidateEvent from "../../shared/validate-event/validate-event";
import ClaroluzEventDispatch from "../../../../../infra/services/claroluz-event-dispatch";
//endRemoveIf(production)

class ClaroluzCups {
    constructor() {
        this.selectEvent();
        this.keyType();
        this.submitEvent();
    }

    private selectEvent() {
        document.querySelectorAll('.cups-selector-btn').forEach((btn: any) => {
            btn.addEventListener('click', () => {
                let actionBox = document.querySelector('.claroluz-cups .claroluz-action-box-content') as HTMLElement;

                switch (btn.getAttribute('data-option')) {
                    case '1':
                        actionBox.classList.remove('option-2');
                        actionBox.classList.add('option-1');
                        this.clearErrors();
                        break;
                    case '2':
                        actionBox.classList.remove('option-1');
                        actionBox.classList.add('option-2');
                        this.clearErrors();
                        break;

                    default:
                        break;
                }
            });
        });
    }

    private clearErrors() {
        document.querySelector('.claroluz-send-cups')?.removeAttribute('disabled');
        document.querySelectorAll('.has-error').forEach((input: any) => {
            input.classList.remove('has-error');
        });

        ClaroluzAlerts.hide();
    }

    private keyType() {
        document.querySelectorAll('.cups-input').forEach((input: any) => {
            input.addEventListener('keyup', (event: any) => {
                new ClaroluzValidateEvent();
            });
        });
    }

    private submitEvent() {
        document.addEventListener('claroluz_send_cups', () => {
            const cups = document.querySelector<HTMLInputElement>('.cups-number')!.value;
            const price = document.querySelector<HTMLInputElement>('.cups-price')!.value;

            if (cups != '' && price != '') {
                const actionBox = document.querySelector('.claroluz-cups .claroluz-action-box-content') as HTMLElement;
                let data = new ClaroluzCupsData({
                    cups: cups,
                    price: new FloatWithTwoDecimals(parseFloat(price))
                });

                if (actionBox.classList.contains('option-1')) {
                    data.setOptions({
                        type: CupsOption.Power,
                        powerP1: parseFloat(document.querySelector<HTMLInputElement>('.cups-p1')!.value),
                        powerP2: parseFloat(document.querySelector<HTMLInputElement>('.cups-p2')!.value),
                        powerP3: parseFloat(document.querySelector<HTMLInputElement>('.cups-p3')!.value),
                    });

                } else if (actionBox.classList.contains('option-2')) {
                    data.setOptions({
                        type: CupsOption.Month,
                        month: parseInt(document.querySelector<HTMLInputElement>('.cups-month')!.value)
                    });
                }

                new ClaroluzEventDispatch('claroluz_submit', { type: 'cups', data: data });
            }
        });
    }
}

//removeIf(production)
export default ClaroluzCups;

function appProperties(): import("../../../../../infra/critical/claroluz-events-properties").default {
    throw new Error("Function not implemented.");
}
//endRemoveIf(production)
